import { useEffect, useState } from "react";
import defaultTeamImage from "../../assets/teamicon.png";

const AssistsTab = ({ tournament, selectedSubcategory }) => {
  const [topAssists, setTopAssists] = useState([]);
  const [loading, setLoading] = useState(true);
  const defaultPlayerImage =
    "https://cdn-icons-png.flaticon.com/512/149/149071.png";

  useEffect(() => {
    if (!tournament?.id) return;

    const fetchTopAssists = async () => {
      try {
        const url = selectedSubcategory
          ? `https://server-postgre.vercel.app/api/goals/${tournament.id}/assists?subcategoryId=${selectedSubcategory.id}`
          : `https://server-postgre.vercel.app/api/goals/${tournament.id}/assists`;

        const res = await fetch(url);
        const data = await res.json();
        setTopAssists(data);
      } catch (error) {
        console.error("Error al cargar asistencias:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchTopAssists();
  }, [tournament, selectedSubcategory]);

  if (loading) return <p>Cargando asistencias...</p>;

  return (
    <div>
      <h3 className="font-semibold mb-3 text-blue-700 flex items-center">
        🅰️ Asistencias
      </h3>
      {topAssists.length > 0 ? (
        <div className="space-y-2">
          {topAssists.map((player, index) => (
            <div
              key={player.player_id}
              className="flex items-center p-3 bg-white rounded-lg border border-blue-200 shadow-sm hover:shadow-md transition"
            >
              {/* Posición */}
              <span className="w-8 text-center font-bold text-gray-700">
                {index + 1}°
              </span>

              {/* Jugador */}
              <div className="flex items-center flex-1 ml-4">
                <img
                  src={player.profile_picture_url || defaultPlayerImage}
                  alt={player.player_name}
                  className="w-10 h-10 rounded-full object-cover border-2 border-white shadow"
                />

                <div className="ml-3 flex-1">
                  <h4 className="font-medium text-gray-900">
                    {player.player_name}
                  </h4>
                  <div className="flex items-center mt-1">
                    {player.team_logo && (
                      <img
                        src={player.team_logo || defaultTeamImage}
                        alt={player.team_name}
                        className="w-5 h-5 mr-2 object-contain"
                      />
                    )}
                    <span className="text-xs text-gray-600">
                      {player.team_name}
                    </span>
                  </div>
                </div>
              </div>

              {/* Asistencias */}
              <div className="ml-auto bg-blue-100 px-3 py-1 rounded-full border border-blue-400 flex items-center">
                <span className="font-bold text-blue-800">
                  {player.assists}
                </span>
                <span className="text-xs text-blue-700 ml-1">asistencias</span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500">No hay datos de asistencias disponibles</p>
      )}
    </div>
  );
};

export default AssistsTab;
